module.exports = __webpack_public_path__ + "img/cloud-drizzle.6f71a08a.svg";